const hamburgerHelper = {
    closed: {
        status: 'closed',
        topToggled: '',
        middleToggled: '',
        bottomToggled: '',
        topBladeToggled: '',
        middleBladeToggled: '',
        bottomBladeToggled: '',
        gripToggled: ''
    },
    deployed: {
        status: 'deployed',
        topToggled: 'top-toggled',
        middleToggled: 'middle-toggled',
        bottomToggled: 'bottom-toggled',
        topBladeToggled: 'top-blade-toggled',
        middleBladeToggled: 'middle-blade-toggled',
        bottomBladeToggled: 'bottom-blade-toggled',
        gripToggled: 'grip-toggled'    
    }
};

export default hamburgerHelper;